import React, { Component } from "react";
import { connect } from "react-redux";
import { brandActions } from "redux/actions/brand-actions";
import Select from "react-select";
import { helperFunctions as HF } from "../../../helper/helperFunctions";

class BrandsDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.props.stateProp,
            selected_value: "",
            selected_model: null
        };
    }

    componentDidMount() {
        this.setState({ selected_value: this.props.selectedCustomer, selected_model: this.props.modelProp });
        this.props.getDropDownList(1, "", "", 10);
    }

    getOptions(data) {
        if (data == undefined) {
            return [];
        }
        return data.map(({ id, title }) => ({
            value: id,
            label: title
        }));
    }

    handleChange = e => {
        let value = undefined;
        if (e == null) {
            value = undefined;
        } else {
            value = e.value;
        }
        this.setState({
            selected_value: value
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.state.selected_value !== prevState.selected_value) {
            this.props.onReturnFullState({
                model_id: this.state.selected_value
            });
        }
    }

    render() {
        const customers = this.getOptions(this.props.brandsData);
        const { selected_value, selected_model } = this.state;
        return (
            <div className="flexElem alignCenter">
                <div
                    className="col-md-4 no-padding"
                >
                    Currently Editing:
                </div>
                <div className="col-md-8 no-padding brandsDropdown">
                    <Select
                        value={HF.returnLabelWithValue(selected_value, customers)}
                        onChange={this.handleChange}
                        options={customers.sort((a, b) => a.label.localeCompare(b.label))}
                        isSearchable={true}
                        isMulti={false}
                        placeholder={"Select Brand"}
                        isClearable={true}
                        isDisabled={selected_model === 'App\\Brand'}
                    />
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getDropDownList: (page, filter, sort, pageSize) => {
            dispatch(
                brandActions.getBrandsListDropDown(page, filter, sort, pageSize)
            );
        }
    };
};

function mapStateToProps(state) {
    const { brandsData } = state.brandReducer;
    return {
        brandsData
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BrandsDropdown);



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/BrandsDropdown.jsx